import script from "./BottomBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomBar.vue?vue&type=script&setup=true&lang=ts"

import "./BottomBar.vue?vue&type=style&index=0&id=78730ec8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78730ec8"]])

export default __exports__